import { IonPage, IonButton, IonCheckbox, IonPopover, IonCol, IonContent, IonGrid, IonInput, IonItem, IonLabel, IonRow, IonText, useIonViewWillEnter } from "@ionic/react";
import { FC, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { User } from "../../../models/data";
import { translation } from "../../../models/translation";
import { createDonation, fetchUserBalance_b } from "../../../services/donate_service";
import { fetchSingleFundraiser } from "../../../services/fundraise_service";
import UserTerms from "../../../components/UserTerms";
import { Link } from "react-router-dom";

interface FundraiserFormProps {
    user: User
}


export const DonateToFundraiserCrd: FC<FundraiserFormProps> = ({ user }) => {

    const history = useHistory();

    const location = useLocation();

    const params = new URLSearchParams(location.search)

    const fundraiserId = params.get('id');

    const siteText = translation();

    const lan = siteText.lan.replace("/", "")

    const tomorrow = new Date();

    tomorrow.setDate(new Date().getDate() + 1);

    const year = tomorrow.getFullYear();

    let month = `${tomorrow.getMonth() + 1}`;
    let day = `${tomorrow.getDate()}`;

    if (month.length < 2) { month = 0 + month };
    if (day.length < 2) { day = 0 + day };

    const minDate = `${year}-${month}-${day}`;

    const [fundraiser, setFundraiser] = useState<any>()

    const [agreeToTerms, setAgreeToTerms] = useState(false)

    const [amount, setAmount] = useState<number>(() => 0)
    const [balance, setBalance] = useState<number>(() => 0)
    const [anonymous, setAnonymous] = useState(() => { return false })

    const popover = useRef<HTMLIonPopoverElement>(null);
    const [popoverOpen, setPopoverOpen] = useState(false);

    const [disabled, setDisabled] = useState<boolean>(false);
    const [isProcesseng, setIsProcessing] = useState<string>()

    const [userTerms, showUserTerms] = useState<boolean>(false);


    useIonViewWillEnter(() => {
        getFundraiser()
    }, [fundraiserId])

    useIonViewWillEnter(() => {
        fetchCurrentUserBalance()
    })

    const getFundraiser = () => {
        if (fundraiserId) {
            fetchSingleFundraiser(fundraiserId).then(m => {
                if (m.message) {
                    setFundraiser(m.message)
                }
            })
        }
    }

    /*Close open user terms  */
    const toggleUserTerms = () => {
        let current = userTerms;
        showUserTerms(!current);
    }


    /** */
    const fetchCurrentUserBalance = async () => {

        await fetchUserBalance_b(user.id).then(
            m => {
                if (!m?.error) {
                    setBalance(m?.message)
                }
            }
        );

    }
    const submit = (event: any) => {

        //
        event.preventDefault();

        setDisabled(!disabled)
        setIsProcessing('processing')
        setPopoverOpen(true)
        //
        createDonation({
            title: `${user.firstName}_on_${month}_${day}_number-${Math.floor(Math.random() * 60)}`,
            status: "publish",
            acf: {
                status: "completed",
                beneficiary: fundraiserId,
                beneficiary_type: 'fundraiser',
                anonymous: `${anonymous}`,
                amount: amount,
                tip: 0,
                commission: 0,
                date: minDate,
                donation_method: "sw_account",
                frequency: 'single'
            }
        }).then(m => {
            if (!m?.message) {
                setIsProcessing('error')
                console.log(m)
            } else {
                setIsProcessing('done')
            }
        })
    }

    const completeDonation = () => {
        setPopoverOpen(false)
        setTimeout(() => {
            history.push(`/${lan}/account/start`)
        }, 30)
    }
    return (
        <IonPage>
            <IonContent>
                {!userTerms ? <IonGrid className="innerBody sw_sp_md">
                    <IonRow>
                        <IonCol offsetSm="1" offsetMd="1" sizeSm="10" sizeMd="8" >
                            {fundraiser && <h1>{siteText.fundraiseDonateStepTitle.replace("%%title%%", fundraiser.title.rendered)}</h1>}

                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol className="ion-margin-top" offsetSm="1" offsetMd="1" sizeSm="10" sizeMd="8">
                            <p>{siteText.donateUseCreditStartIndication.replace("%%amount%%", balance.toString())}</p>
                            <form onSubmit={submit}>

                                <IonLabel position="stacked">{siteText.fundraiseDonateStepAmountLabel}</IonLabel>
                                <IonItem lines="none" className="cashField ion-margin-top ion-margin-bottom">
                                    <IonInput
                                        value={amount}
                                        onIonChange={e => setAmount(e.detail.value ? +e.detail.value : 0)}
                                        placeholder={siteText.fundraiseDonateStepAmountPhl} min="0" type="number">
                                    </IonInput>
                                    <IonText>CHF</IonText>
                                </IonItem>

                                <IonItem lines="none" className="borderedInput">
                                    <IonLabel>
                                        {siteText.fundraiseDonateStepAnonymous}
                                    </IonLabel>
                                    <IonCheckbox onIonChange={e => setAnonymous(e.detail.checked)} checked={anonymous} slot="start" />
                                </IonItem>

                                <IonItem lines="none" className="borderedInput ion-margin-top">
                                    <IonLabel><Link to="terms_of_use" onClick={(e: any) => { e.preventDefault(); toggleUserTerms(); }}>{siteText.fundraiseDonateStepTermsConfrim}</Link>
                                    </IonLabel>
                                    <IonCheckbox checked={agreeToTerms} onIonChange={e => setAgreeToTerms(e.detail.checked)} slot="start" />
                                </IonItem>
                                {balance < amount && <p><IonText color="danger">{siteText.donateUseCreditStartInsufficientCr}</IonText></p>}

                                <IonButton disabled={!agreeToTerms || amount === 0 || (balance<amount)} slot="end" className="ion-margin-top" type="submit">
                                    {siteText.fundraiseDonateStepPrimary}
                                </IonButton>
                                {balance < amount &&
                                    <IonButton fill="outline" className="ion-margin-top" type="button" routerLink={`/${lan}/account/credit`}>
                                        <IonText>{siteText.donateUseCreditAltTxt}</IonText>
                                    </IonButton>
                                }

                            </form>
                        </IonCol>
                    </IonRow>
                    <IonPopover ref={popover} isOpen={popoverOpen} backdropDismiss={false}>
                        <IonContent>
                            <IonGrid>
                                <IonRow className="ion-padding">
                                    {isProcesseng === 'processing' &&
                                        <IonCol size="12">{siteText.donateUseCreditDetailsProcessing}</IonCol>}
                                    {isProcesseng === 'done' && <IonCol size="12">
                                        <p>{siteText.donateUseCreditDetailsSuccess}
                                        </p>
                                        <IonButton color="success" onClick={completeDonation}> <IonText color="light">{siteText.donateUseCreditDetailsDoneString}</IonText> </IonButton>
                                    </IonCol>}
                                    {isProcesseng === 'error' && <IonCol size="12">
                                        <p>{siteText.donateUseCreditDetailsError}
                                        </p>
                                        <IonButton color="secondary" onClick={e => setPopoverOpen(false)}><IonText color="light">{siteText.donateUseCreditDetailsTryAgainString}</IonText> </IonButton>
                                    </IonCol>}
                                </IonRow>
                            </IonGrid>
                        </IonContent>
                    </IonPopover>
                </IonGrid> : <UserTerms goBack={toggleUserTerms}></UserTerms>}

            </IonContent>
        </IonPage>
    )
}

export default DonateToFundraiserCrd;